// extracted by mini-css-extract-plugin
var _1 = "VH8q2__userInfo";
export { _1 as "userInfo" }
